import React from 'react';
const COLORS=['#2563eb','#16a34a','#d97706','#9333ea','#dc2626','#0891b2','#0284c7','#b45309'];
export function Avatar({name='?',idx=0,size=34}){
  const ini=(name||'?').split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase();
  const bg=COLORS[idx%COLORS.length];
  return<div style={{width:size,height:size,borderRadius:'50%',background:bg+'22',color:bg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:size*.35,fontWeight:700,flexShrink:0}}>{ini}</div>;
}
